import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { colors, shadows, radii, fillImageSx, sharpImageSx } from '../../theme/designTokens';

const AnimatedImage = ({
  src,
  alt,
  maxHeight = 420,
  float = true,
  accent = true,
  objectPosition = 'center',
  fit = 'cover',
}) => (
  <Box sx={{ position: 'relative', width: '100%' }}>
    {accent && (
      <>
        <Box
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{ duration: 28, repeat: Infinity, ease: 'linear' }}
          sx={{
            position: 'absolute',
            top: -12,
            right: -12,
            width: { xs: 80, md: 100 },
            height: { xs: 80, md: 100 },
            borderRadius: '50%',
            border: `2px dashed ${colors.gold}`,
            opacity: 0.45,
            pointerEvents: 'none',
          }}
        />
        <Box
          component={motion.div}
          animate={{ scale: [1, 1.08, 1], opacity: [0.35, 0.55, 0.35] }}
          transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            position: 'absolute',
            bottom: -16,
            left: -16,
            width: { xs: 100, md: 130 },
            height: { xs: 100, md: 130 },
            borderRadius: radii.lg,
            background: `linear-gradient(135deg, rgba(238,186,43,0.25) 0%, rgba(23,34,67,0.08) 100%)`,
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
      </>
    )}
    <Box
      component={motion.div}
      animate={float ? { y: [0, -10, 0] } : undefined}
      transition={float ? { duration: 5, repeat: Infinity, ease: 'easeInOut' } : undefined}
      whileHover={{ scale: 1.02 }}
      sx={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxHeight: fit === 'cover' ? maxHeight : 'none',
        height: fit === 'cover' ? maxHeight : 'auto',
        overflow: 'hidden',
        borderRadius: radii.xl,
        boxShadow: shadows.lg,
        border: `3px solid ${colors.white}`,
        outline: `1px solid ${colors.borderLight}`,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        decoding="async"
        loading="lazy"
        sx={
          fit === 'cover'
            ? { ...fillImageSx, objectPosition }
            : { ...sharpImageSx, width: '100%', height: 'auto' }
        }
      />
    </Box>
  </Box>
);

export default AnimatedImage;
